import React, { memo, useCallback } from 'react';
import { Icon } from '@ann/web-components';
import {
  ItemLeft,
  ItemLabel,
  ItemRight,
  ItemRow,
} from './FolderNavigationItem.styled';

const FolderNavigationItem = ({
  item,
  isSelected = false,
  isRootLevel = true,
  onNavigate,
}) => {
  const hasChildren = Array.isArray(item?.children) && item.children.length > 0;

  const handleNavigate = useCallback(() => {
    onNavigate?.(item);
  }, [item, onNavigate]);

  return (
    <ItemRow type="button" onClick={handleNavigate} $isSelected={isSelected}>
      <ItemLeft>
        {isRootLevel && (
          <Icon name={item?.icon || 'folder'} size="small" color="primary-alt" />
        )}
        <ItemLabel $isSelected={isSelected}>{item?.name}</ItemLabel>
      </ItemLeft>
      {hasChildren && (
        <ItemRight>
          <Icon name="chevronRight" size="small" color="neutral" />
        </ItemRight>
      )}
    </ItemRow>
  );
};

export default memo(FolderNavigationItem);
